import { Authorization } from "../state/authAtoms";
import { HostId } from "../state/atoms";
import { updateFiles } from "../lib/messageBus";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";

const LoadData = () => {
	const hostId = useRecoilValue(HostId);
	const auth = useRecoilValue(Authorization);
	useEffect(() => {
		if (!auth.isLoggedIn || !hostId) return;
		updateFiles(hostId);
	}, [hostId, auth.isLoggedIn]);

	return <></>;
};

export default LoadData;
